export default function Face() {
    return (
        <>
            
            <div className="fb-comments" data-mobile="true" data-href="dosis-utiles.web.app/" data-width="" data-numposts="5"></div>
        </>
    )
}